import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setIsWidth } from '../../store/slice/currentStageSlice';
import { currentStageData } from '../../store/slice/currentStageSlice';
import Dashboard from '../graph-dashboard/GraphDashboard';
function MisDashboard() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setIsWidth(false))
    dispatch(currentStageData(''))
  }, [])
  return (
    <Dashboard />
  )
}

export default MisDashboard